module.exports = __webpack_public_path__ + "media/Loops 110 Perc.d93806fb.wav";